import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { AppService } from "src/app/services/services";
import { ValidationService } from '../../validators/validation.service';
import { Router } from "@angular/router";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { Modal } from 'bootstrap';
import { EncryptionService } from "src/app/services/encryption.service";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";

@Component({
    selector: 'nri-app-nominee',
    templateUrl: './nominee.component.html',
    styleUrls: ['./nominee.component.scss']
})

export class NomineeComponent implements OnInit {
    erefNo: any;
    errorMsg: string = '';
    nominee: string = '';
    nomineeArray: any = [];
    nnModal: any;
    nominee1: any;
    nominee2: any;
    nominee3: any;
    nominee1InfoId: string = '';
    nominee2InfoId: string = '';
    nominee3InfoId: string = '';
    nomineeGetData: any = '';
    optionsGuardian: INgxMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };
    share1: number = 0;
    share2: number = 0;
    share3: number = 0;
    totalShare: number = 0;
    deletNomineeValidate: boolean;
    deleteNomineItem: any;
    printNominee: string = '';
    // --- Nominee opt-out declaration state ---
    // optOutConfirmed is true only once the customer has confirmed the
    // declaration popup (or once a previously saved opt-out is restored).
    optOutConfirmed: boolean = false;
    // Snapshot taken when the popup opens, so Cancel can restore it.
    optOutWasConfirmed: boolean = false;
    // True once DIYGetNomineeOptOut has returned a saved declaration record.
    optOutSaved: boolean = false;
    optOutCheck1: boolean = false;
    optOutCheck2: boolean = false;
    optOutCheck3: boolean = false;
    @ViewChild('errorComp') errorComp: ErrorModalComponent;
    @Output() updateNomineeStatus = new EventEmitter<boolean>();

    constructor(private toastr: ToastrService, private http: EncryptionService, public _http: AppService, private router: Router, public loader: NgxUiLoaderService) {
        this._http.getRefNum().subscribe(data => {
            this.erefNo = data;
        });
    }

    ngOnInit() {
        this.getNomineeDetails();
        const element = document.getElementById('nnModal') as HTMLElement;
        this.nnModal = new Modal(element, { backdrop: 'static', keyboard: false });
        this._http.scroll();
    }

    overallStatus() {
        let url = 'DIY/DIYOverallStatus';
        this.loader.start();
        let checkSum = this.erefNo;
        let params = {
            'ReferenceNumber': this.erefNo,
        }
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                if (data && data.IsSuccess) {
                    let item = data.overallLists;
                }

            },
            error: _error => {
                this.loader.stop();
                // this.toastr.error(_error.error.Message)
                this.errorComp.ModalShow(_error.error.Message);
            }
        })
    }

    addNominee() {
        this.nominee = 'Y';
        if (!this.nomineeGetData && (this.nomineeArray.length === 0 || this.nomineeArray.length === 1)) {
            this.nomineeArray[0].shareValue = 100;
            this.nomineeArray[0].add = false;
            this.nomineeArray[0].show = true;
            this.nomineeArray[0].item = 1;
        }
        sessionStorage.setItem("nomineeStage", JSON.stringify(false));
        this.updateNomineeStatus.emit(false);
    }


    nomineeClick() {
        if (this.nominee === 'Y') {
            this.nomineeArray = [];
            this.nomineeArray.push({ item: 1, show: true, shareValue: 100, add: false });
            sessionStorage.setItem("nomineeStage", JSON.stringify(false));
            this.updateNomineeStatus.emit(false);
            this.printNominee = '';
            // Choosing Yes cancels any opt-out the customer had in progress.
            this.resetOptOut();
        } else {
            this.nomineeNoClick();
        }
    }

    // Bound to a click rather than a change, because clicking the No option
    // when it is already selected raises no change event - and the customer
    // must still be able to re-open the declaration.
    nomineeNoClick() {
        this.nominee = 'N';
        this.nominee1 = '';
        this.nominee2 = '';
        this.nominee3 = '';
        this.printNominee = 'N';
        this.openOptOutModal();
    }

    // Opens the declaration. The three acknowledgements are always presented
    // ticked; for an application that already opted out they show whatever
    // DIYGetNomineeOptOut returned.
    openOptOutModal() {
        // Remembered so Cancel can put things back exactly as they were.
        this.optOutWasConfirmed = this.optOutConfirmed;
        // Clear first so nothing left over from an earlier visit is shown even
        // for a moment, then re-read the saved declaration - the ticks always
        // come from DIYGetNomineeOptOut and from nothing else.
        this.optOutCheck1 = false;
        this.optOutCheck2 = false;
        this.optOutCheck3 = false;
        this.getNomineeOptOut();
        this.nnModal.show();
    }

    // Clears every opt-out declaration value. Used when the customer moves
    // back to Yes, and when a No answer is abandoned.
    resetOptOut() {
        this.optOutConfirmed = false;
        this.optOutSaved = false;
        this.optOutCheck1 = false;
        this.optOutCheck2 = false;
        this.optOutCheck3 = false;
    }

    // Cancel on the declaration popup: nothing is saved and the Yes/No answer
    // goes back to unanswered, so the customer has to answer again (and so the
    // radio change event can re-open this popup).
    cancelOptOut() {
        if (this.optOutWasConfirmed) {
            // The customer had already opted out and simply re-read the
            // declaration - leave the saved answer alone.
            this.optOutConfirmed = true;
            return;
        }
        this.nominee = '';
        this.printNominee = '';
        this.resetOptOut();
        sessionStorage.setItem("nomineeStage", JSON.stringify(false));
        this.updateNomineeStatus.emit(false);
    }

    // Used when a save fails. The answer goes back to unanswered, but the
    // ticks are kept so the customer does not have to re-enter them after a
    // network problem.
    abandonOptOut() {
        if (this.optOutWasConfirmed) {
            // A previously saved opt-out is still valid on the server.
            this.optOutConfirmed = true;
            return;
        }
        this.nominee = '';
        this.printNominee = '';
        this.optOutConfirmed = false;
        sessionStorage.setItem("nomineeStage", JSON.stringify(false));
        this.updateNomineeStatus.emit(false);
    }

    // Confirm on the declaration popup: save the three checkbox answers, then
    // continue with the existing no-nominee flow (which removes any nominee
    // records the customer had saved earlier and then saves the stage).
    confirmOptOut() {
        const url = 'DIY/DIYUpdtNomineeOptOut';
        // The three declarations are a single mandatory acknowledgement - the
        // customer cannot untick them, so a confirmation is always Y/Y/Y.
        this.optOutCheck1 = true;
        this.optOutCheck2 = true;
        this.optOutCheck3 = true;
        const params = {
            "ReferenceNumber": this.erefNo,
            "NCheckBox1": 'Y',
            "NCheckBox2": 'Y',
            "NCheckBox3": 'Y'
        }
        const checkSum = this.erefNo;
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                const optOutVal = this.http.decryptUsingAES256(data.OutPut);
                if (optOutVal && optOutVal.IsSuccess) {
                    this.optOutConfirmed = true;
                    this.optOutSaved = true;
                    this.noNominee();
                } else {
                    this.abandonOptOut();
                    this.errorComp.ModalShow((optOutVal && optOutVal.Error) || 'Something Went Wrong');
                }
            },
            error: error => {
                this.loader.stop();
                this.abandonOptOut();
                if (!window.navigator.onLine) {
                    this.errorComp.ModalShow('It appears that your internet connectivity is slow or please try again.');
                } else {
                    this.errorComp.ModalShow(error.error.Message);
                }
            }
        })
    }

    // Reads back a previously saved opt-out declaration so the popup answers
    // survive a page reload. A failure here must never block the page.
    getNomineeOptOut() {
        const url = 'DIY/DIYGetNomineeOptOut';
        const params = {
            "ReferenceNumber": this.erefNo
        }
        const checkSum = this.erefNo;
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                const optOutVal = this.http.decryptUsingAES256(data.OutPut);
                // This API restores the declaration acknowledgement ONLY. It must
                // never decide the Yes/No selection - that comes from
                // DIYGetNominee.NomineeFlag and nothing else.
                //
                // Each value is compared strictly against 'Y'. A loose truthiness
                // check is wrong here: the string "N" is truthy in JavaScript, so
                // an unacknowledged record would read as a confirmed opt-out.
                // Show exactly what was saved: 'Y' ticks the box, anything else
                // - including the string 'N' or a missing value - leaves it clear.
                // The strict comparison matters because 'N' is truthy in JavaScript.
                const ok = !!(optOutVal && optOutVal.IsSuccess);
                this.optOutCheck1 = ok && optOutVal.NCheckBox1 === 'Y';
                this.optOutCheck2 = ok && optOutVal.NCheckBox2 === 'Y';
                this.optOutCheck3 = ok && optOutVal.NCheckBox3 === 'Y';
                this.optOutSaved = ok;
                // The declaration counts as confirmed only when all three were
                // acknowledged, which is all DIYUpdtNomineeOptOut ever writes.
                this.optOutConfirmed =
                    this.optOutCheck1 && this.optOutCheck2 && this.optOutCheck3;
            },
            error: _error => {
                // Nothing could be read, so show no acknowledgement rather than
                // whatever happened to be in memory.
                this.optOutCheck1 = false;
                this.optOutCheck2 = false;
                this.optOutCheck3 = false;
                this.optOutSaved = false;
                this.optOutConfirmed = false;
            }
        })
    }

    // Applies a confirmed opt-out: removes any nominees the customer saved
    // earlier and records the no-nominee choice. It deliberately does NOT move
    // the customer on - they continue with the page's own Next button.
    noNominee() {
        let del = 0
        this.nomineeArray = [];
        if (this.nominee1InfoId) {
            del++;
            this.deletNominee(this.nominee1InfoId);
        }
        if (this.nominee2InfoId) {
            del++;
            this.deletNominee(this.nominee2InfoId);
        }
        if (this.nominee3InfoId) {
            del++;
            this.deletNominee(this.nominee3InfoId);
        }

        if (del === 0) {
            this.deletNomineeValidate = false;
            // Save the no-nominee choice without navigating. When there were
            // nominees to delete, the delete chain reaches updateStage() on its
            // own once the last one is gone.
            this.updateStage();
        }
    }

    getNomineeDetails() {
        let checkSum = this.erefNo;
        let url = "DIY/DIYGetNominee";
        let params = {
            "ReferenceNumber": this.erefNo,
            "Validate": checkSum
        }
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let getNomineeVal = this.http.decryptUsingAES256(data.OutPut)
                this.nomineeGetData = '';
                const info = (getNomineeVal && Array.isArray(getNomineeVal.NomineeInfo))
                    ? getNomineeVal.NomineeInfo : [];
                // The saved Yes/No answer is returned INSIDE NomineeInfo[0], not at
                // the root of the response. The root is checked only as a fallback.
                // 'Y' = yes, 'N' = no, '' or null = the customer has not answered.
                const savedFlag = (info.length && info[0].NomineeFlag)
                    ? info[0].NomineeFlag
                    : (getNomineeVal ? getNomineeVal.NomineeFlag : '');
                if (getNomineeVal && getNomineeVal.IsSuccess) {
                    // sessionStorage.setItem("nomineeStage",JSON.stringify(getNomineeVal.IsSuccess));
                    this.nomineeArray = [];
                    this.nominee1 = '';
                    this.nominee2 = '';
                    this.nominee3 = '';
                    this.printNominee = info.length ? info[0].SOA : '';
                    // NomineeName is now always sent blank - the real name lives in
                    // NomineeFirstName / NomineeLastName - so a saved nominee is
                    // detected from those (NomineeName kept for older records).
                    const hasSavedNominee = info.length &&
                        (info[0].NomineeFirstName || info[0].NomineeLastName || info[0].NomineeName);
                    if (getNomineeVal.IsNominee && hasSavedNominee) {
                        let l = getNomineeVal.NomineeInfo.length;
                        this.nominee1InfoId = getNomineeVal.NomineeInfo[0].NomineeInfoId;
                        this.nomineeGetData = getNomineeVal.NomineeInfo;
                        this.nominee1 = this.mapSavedNominee(getNomineeVal.NomineeInfo[0]);
                        this.nomineeArray.push({ item: 1, show: true, add: false, id: this.nominee1InfoId, shareValue: getNomineeVal.NomineeInfo[0].Share });
                        if (l === 2) {
                            this.nominee2InfoId = getNomineeVal.NomineeInfo[1].NomineeInfoId;
                            this.nomineeArray.push({ item: 2, show: true, add: false, id: this.nominee2InfoId, shareValue: getNomineeVal.NomineeInfo[1].Share });
                            this.nominee2 = this.mapSavedNominee(getNomineeVal.NomineeInfo[1]);
                        }
                        else if (l === 3) {
                            this.nominee2InfoId = getNomineeVal.NomineeInfo[1].NomineeInfoId;
                            this.nominee3InfoId = getNomineeVal.NomineeInfo[2].NomineeInfoId;
                            // Nominee 2 was never seeded here at all.
                            this.nominee2 = this.mapSavedNominee(getNomineeVal.NomineeInfo[1]);
                            this.nominee3 = this.mapSavedNominee(getNomineeVal.NomineeInfo[2]);
                            this.nomineeArray.push({ item: 2, show: true, add: false, id: this.nominee2InfoId, shareValue: getNomineeVal.NomineeInfo[1].Share });
                            this.nomineeArray.push({ item: 3, show: true, add: false, id: this.nominee3InfoId, shareValue: getNomineeVal.NomineeInfo[2].Share });
                        }
                        this.nominee = 'Y';
                    } else if (savedFlag === 'Y' || savedFlag === 'N') {
                        // The server knows what the customer answered - use it.
                        this.nominee = savedFlag;
                        if (savedFlag === 'Y') {
                            // Answered Yes but no nominee saved yet - show a blank card
                            // so the customer has somewhere to enter the details.
                            this.nomineeArray = [{ item: 1, show: true, shareValue: 100, add: false }];
                        }
                    } else {
                        // No nominee records and no saved answer. This is NOT the
                        // same as the customer choosing No - leave it unanswered.
                        this.nominee = '';
                    }
                    this.getNomineeOptOut();
                } else {
                    // Even on a failed read the saved answer must survive.
                    this.nominee = (savedFlag === 'Y' || savedFlag === 'N') ? savedFlag : '';
                    this.getNomineeOptOut();
                }
            },
            error: error => {
                this.loader.stop();
                this.nominee = '';
                this.getNomineeOptOut();
            }
        })
    }

    shareValueCheck(event: any) {
        if (event.delete && event.delete === 2) {
            this.share2 = 0;
        }
        if (event.delete && event.delete === 3) {
            this.share3 = 0;
        }
        if (event.item === 1) {
            this.share1 = this.nomineeArray[0].shareValue ? parseInt(this.nomineeArray[0].shareValue) : 0;
        } else {
            if (this.nominee1) {
                this.share1 = this.nominee1.NomineeShare ? parseInt(this.nominee1.NomineeShare) : 0;
            }
        }
        if (event.item === 2 && this.nomineeArray[1]) {
            this.share2 = this.nomineeArray[1].shareValue ? parseInt(this.nomineeArray[1].shareValue) : 0;
        } else {
            if (this.nominee2) {
                this.share2 = this.nominee2.NomineeShare ? parseInt(this.nominee2.NomineeShare) : 0;
            }
        }
        if (event.item === 3 && this.nomineeArray[2]) {
            this.share3 = this.nomineeArray[2].shareValue ? parseInt(this.nomineeArray[2].shareValue) : 0;
        } else {
            if (this.nominee3) {
                this.share3 = this.nominee3.NomineeShare ? parseInt(this.nominee3.NomineeShare) : 0;
            }
        }

        this.totalShare = this.share1 + this.share2 + this.share3;
        if (this.totalShare > 100) {
            let l = this.nomineeArray.length;
            if (l === 1) {
                //this.nomineeArray[0].shareValue = 100;
                //this.nomineeArray[0].totalShare = 100;
                this.nomineeArray[0].add = false;
            }
            else if (l === 2) {
                // this.nomineeArray[0].shareValue = 50;
                // this.nomineeArray[1].shareValue = 50;
                this.nomineeArray[0].add = false;
                this.nomineeArray[1].add = false;
                this.nomineeArray.forEach((e: any) => {
                    e.totalShare = 100
                })
            }
            else {
                //  this.nomineeArray[0].shareValue = 34;
                //  this.nomineeArray[1].shareValue = 33;
                // this.nomineeArray[2].shareValue = 33;
                this.nomineeArray[0].add = false;
                this.nomineeArray[1].add = false;
                this.nomineeArray.forEach((e: any) => {
                    e.totalShare = 100
                })
            }
        } else {
            let l = this.nomineeArray.length;
            if (l === 1) {
                this.nomineeArray[0].shareValue = this.share1;
                if (this.totalShare === 100) {
                    this.nomineeArray[0].add = false;
                    this.nomineeArray[0].totalShare = 100;
                } else {
                    this.nomineeArray[0].add = true;
                }
            }
            else if (l === 2) {
                this.nomineeArray[0].shareValue = this.share1;
                this.nomineeArray[1].shareValue = this.share2;
                if (this.totalShare === 100) {
                    this.nomineeArray[0].add = false;
                    this.nomineeArray[1].add = false;
                    this.nomineeArray.forEach((e: any) => {
                        e.totalShare = 100
                    })
                } else {
                    if (this.nomineeArray[1].item) {
                        this.nomineeArray[0].add = false;
                        this.nomineeArray[1].add = true;
                    } else {
                        this.nomineeArray[0].add = true;
                        this.nomineeArray[1].add = false;
                    }
                }
            } else {
                this.nomineeArray[0].shareValue = this.share1;
                this.nomineeArray[1].shareValue = this.share2;
                this.nomineeArray[2].shareValue = this.share3;
                if (this.totalShare === 100) {
                    this.nomineeArray[0].add = false;
                    this.nomineeArray[1].add = false;
                    this.nomineeArray[2].add = false;
                    this.nomineeArray.forEach((e: any) => {
                        e.totalShare = 100
                    })
                } else {
                    this.nomineeArray[0].add = false;
                    this.nomineeArray[1].add = false;
                    this.nomineeArray[2].add = false;
                }
            }
        }
    }

    nomineeAdd(event: any) {
        if (event === 1) {
            if (this.nomineeArray.length === 2) {
                // let a = {item: 2, show: true, add: false, shareValue: 50};
                let a = { item: 2, show: true };
                this.nomineeArray.splice(1, 0, a);
            } else {
                // this.nomineeArray.push({item: 2, show: true, add: false, shareValue: 50});
                this.nomineeArray[0].add = false;
                this.nomineeArray.push({ item: 2, show: true, add: true });
            }
        } else if (event === 2) {
            if (this.nomineeArray[0].item === 2) {
                //let a = {item: 1, show: true, add: false, shareValue: 50};
                let a = { item: 1, show: true };
                this.nomineeArray.splice(0, 0, a);
            } else {
                //this.nomineeArray.push({item: 3, show: true, add: false, shareValue: 50});
                this.nomineeArray[1].add = false;
                this.nomineeArray.push({ item: 3, show: true });
            }
        }

        if (this.nomineeArray.length === 3) {
            this.nomineeArray.forEach((e: any) => {
                //  e.shareValue = 33;
                //   e.add = false;
            });
            //this.nomineeArray[0].shareValue = 34;
        }
        else if (this.nomineeArray.length === 2) {
            this.nomineeArray.forEach((e: any) => {
                // e.shareValue = 50;
                //  e.add = false;
            });
        } else if (this.nomineeArray.length === 1) {
            // this.nomineeArray[0].shareValue = 100;
            // this.nomineeArray[0].add = false;
        }
    }

    deletNominee(id: string) {
        let params = {
            "ReferenceNumber": this.erefNo,
            "NomineeInfoId": id
        }
        let checkSum = this.erefNo + id;
        let url = "DIY/DIYDeleteNominee";
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let delNominee = this.http.decryptUsingAES256(data.OutPut);
                if (delNominee.IsSuccess) {
                    if (id === this.nominee1InfoId) {
                        this.nominee1InfoId = '';
                    }

                    if (id === this.nominee2InfoId) {
                        this.nominee2InfoId = '';
                    }

                    if (id === this.nominee3InfoId) {
                        this.nominee3InfoId = '';
                    }
                    if (!this.nominee1InfoId && !this.nominee2InfoId && !this.nominee3InfoId) {
                        this.updateStage();
                    }
                    else if (this.deletNomineeValidate) {
                        if (!this.nominee1InfoId && this.nominee2InfoId) {
                            this.nominee1InfoId = this.nominee2InfoId;
                            this.nominee2InfoId = this.nominee3InfoId ? this.nominee3InfoId : '';
                        }
                        if (!this.nominee2InfoId && this.nominee3InfoId) {
                            this.nominee2InfoId = this.nominee3InfoId;
                            this.nominee3InfoId = '';
                        }
                        this.nomineeGetData.splice(this.deleteNomineItem, 1);
                        this.updateDeleteNominee();
                    }
                }
            },
            error: _e => {
                this.loader.stop();
            }
        })
    }

    nomineeDelete(event: any) {
        if (!this.nomineeGetData) {
            if (event === 0) {
                this.nominee1 = '';
            }
            if (event === 1) {
                this.nominee2 = '';
            }
            if (event === 2) {
                this.nominee3 = '';
            }
        }
        if (this.nomineeArray[event].id) {
            this.deletNomineeValidate = true;
            if (this.nomineeArray.length === 1 || this.nomineeGetData.length === 1) {
                this.nominee = 'N';
                // Removing the last nominee is also an opt-out, so the
                // declaration has to be confirmed again.
                this.optOutConfirmed = false;
                this.openOptOutModal();
                return;
            } else {
                this.deleteNomineItem = event;
                this.deletNominee(this.nomineeArray[event].id)
            }
        }

        if (this.nomineeArray.length === 1) {
            this.nominee = 'N';
            this.nomineeClick()
        } else {
            this.nomineeArray.splice(event, 1);
            if (this.nomineeArray.length === 1) {
                this.nomineeArray[0].item = 1;
                if (!this.nomineeGetData) {
                    if (event === 0) {
                        if (this.nominee2) {
                            this.nominee1 = this.nominee2;
                        }
                    }
                    this.nominee2 = '';
                }
            } else {
                this.nomineeArray[1].item = 2;
                if (!this.nomineeGetData) {
                    if (event === 0) {
                        if (this.nominee2) {
                            this.nominee1 = this.nominee2;
                            this.nominee2 = '';
                        }
                        if (this.nominee3) {
                            this.nominee2 = this.nominee3;
                        }
                    }
                    if (event === 1) {
                        if (this.nominee3) {
                            this.nominee2 = this.nominee3;
                        }
                    }
                    this.nominee3 = '';
                }
            }
        }
        if (!this.nomineeGetData) {
            this.shareValueCheck('');
        }
    }

    // The API returns its own key names (DOB, NomineeRelation, Share, ...) while
    // validation and the payload builder use the form's names (NomineeDOB,
    // NomineeRelationship, NomineeShare, ...). Seeding a saved nominee with the
    // raw API object left every renamed field reading as undefined - which is
    // why a saved minor was told to select a date of birth it already had, and
    // why a complete nominee was reported as incomplete.
    mapSavedNominee(info: any): any {
        if (!info) {
            return '';
        }
        return {
            NomineeFirstName: info.NomineeFirstName || '',
            NomineeLastName: info.NomineeLastName || '',
            NomineeDOB: info.DOB || '',
            NomineeMobile: info.NomineeMobile || '',
            NomineeCountryCode: info.NomineeCountryCode || '',
            NomineeEmail: info.NomineeEmail || '',
            NomineeRelationship: info.NomineeRelation || '',
            NomineeShare: info.Share,
            Share: info.Share,
            IsMinor: info.IsGuardian ? 'Y' : 'N',
            IsGuardian: info.IsGuardian,
            Idproof: info.NomineeIdProof || '',
            IdNum: info.NomineeIdProofNumber || '',
            GuardianFirstName: info.GuardianFirstName || '',
            GuardianLastName: info.GuardianLastName || '',
            GuardianDOB: '',
            GuardianRelationship: info.GuardianRelation || '',
            GuardianMobile: info.GuardianMobile || '',
            GuardianCountryCode: info.GuardianCountryCode || '',
            GuardianIdProof: info.GuardianIdProof || '',
            GuardianIdProofNumber: info.GuardianIdProofNumber || ''
        };
    }

    // Builds the date string sent to the server as a zero-padded dd/mm/yyyy.
    // Sending 15/6/2010 left the day and month ambiguous and is why a saved
    // date could come back in a shape the page then failed to read.
    formatDob(d: any): string {
        if (!d || !d.day || !d.month || !d.year) {
            return '';
        }
        const pad = (n: any) => ('0' + n).slice(-2);
        return pad(d.day) + '/' + pad(d.month) + '/' + d.year;
    }

    // The name is captured as two fields now, so comparisons that used to run
    // against the single NomineeName build the full name from both parts.
    fullName(n: any): string {
        if (!n) { return ''; }
        return ((n.NomineeFirstName || '') + ' ' + (n.NomineeLastName || '')).trim();
    }

    nomineeData(event: any) {
        if (event.status) {
            if (event.index === 1) {
                if (event.data.NomineeFirstName || event.data.NomineeLastName) {
                    this.nominee1 = event.data;
                    // A major nominee has no date of birth at all.
                    if (!event.data.NomineeDOB) {
                        this.nominee1.NomineeDOB = '';
                    } else if (typeof event.data.NomineeDOB === 'string') {
                        // Already converted by an earlier pass. The emits from the
                        // country-code handlers resend this object untouched, and
                        // treating that string as unrecognised used to blank the date.
                        this.nominee1.NomineeDOB = event.data.NomineeDOB;
                    } else if (event.data.NomineeDOB.formatted) {
                        this.nominee1.NomineeDOB = event.data.NomineeDOB.formatted;
                    } else if (event.data.NomineeDOB.date) {
                        this.nominee1.NomineeDOB =
                            this.formatDob(event.data.NomineeDOB.date);
                    } else {
                        this.nominee1.NomineeDOB = '';
                    }
                } else {
                    this.nominee1 = '';
                }
            }
            else if (event.index === 2) {
                if (event.data.NomineeFirstName || event.data.NomineeLastName) {
                    this.nominee2 = event.data;
                    // A major nominee has no date of birth at all.
                    if (!event.data.NomineeDOB) {
                        this.nominee2.NomineeDOB = '';
                    } else if (typeof event.data.NomineeDOB === 'string') {
                        // Already converted by an earlier pass. The emits from the
                        // country-code handlers resend this object untouched, and
                        // treating that string as unrecognised used to blank the date.
                        this.nominee2.NomineeDOB = event.data.NomineeDOB;
                    } else if (event.data.NomineeDOB.formatted) {
                        this.nominee2.NomineeDOB = event.data.NomineeDOB.formatted;
                    } else if (event.data.NomineeDOB.date) {
                        this.nominee2.NomineeDOB =
                            this.formatDob(event.data.NomineeDOB.date);
                    } else {
                        this.nominee2.NomineeDOB = '';
                    }
                } else {
                    this.nominee2 = '';
                }
            }
            else if (event.index === 3) {
                if (event.data.NomineeFirstName || event.data.NomineeLastName) {
                    this.nominee3 = event.data;
                    // A major nominee has no date of birth at all.
                    if (!event.data.NomineeDOB) {
                        this.nominee3.NomineeDOB = '';
                    } else if (typeof event.data.NomineeDOB === 'string') {
                        // Already converted by an earlier pass. The emits from the
                        // country-code handlers resend this object untouched, and
                        // treating that string as unrecognised used to blank the date.
                        this.nominee3.NomineeDOB = event.data.NomineeDOB;
                    } else if (event.data.NomineeDOB.formatted) {
                        this.nominee3.NomineeDOB = event.data.NomineeDOB.formatted;
                    } else if (event.data.NomineeDOB.date) {
                        this.nominee3.NomineeDOB =
                            this.formatDob(event.data.NomineeDOB.date);
                    } else {
                        this.nominee3.NomineeDOB = '';
                    }
                } else {
                    this.nominee3 = '';
                }
            }

        }
    }

    stageValidate() {
        // The Yes/No answer is mandatory - an unanswered question must never
        // be treated as a No.
        if (this.nominee !== 'Y' && this.nominee !== 'N') {
            this.updateNomineeStatus.emit(false);
            this.errorComp.ModalShow('Please select whether you wish to add a nominee');
            return;
        }
        // A No answer only counts once the opt-out declaration is confirmed.
        // Re-open the popup rather than showing a dead-end message, because
        // clicking the already selected No radio raises no change event.
        if (this.nominee === 'N' && !this.optOutConfirmed) {
            this.updateNomineeStatus.emit(false);
            this.openOptOutModal();
            return;
        }
        let params: any = '';
        let error = 0;
        let checkSum = '';
        this.errorMsg = '';
        this.share1 = 0;
        this.share2 = 0;
        this.share3 = 0;
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
        const aadhaarPattern = /^\d{4}$/;
        const panPattern = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/i;
        if (this.nominee === 'Y' && this.printNominee === '') {
            // Tell the FATCA page it failed, otherwise its timer navigates away
            // and takes this popup with it.
            this.updateNomineeStatus.emit(false);
            this.errorComp.ModalShow('Please select nomination');
            return;
        }
        if (this.nominee === 'N') {
            params = {
                "ReferenceNumber": this.erefNo,
                // Inside this branch the compiler has narrowed nominee to 'N',
                // so false is provably the matching value for NomineeFlag.
                "Nominee": false,
                "NomineeFlag": this.nominee,
                "NomineeInfo": [],
                "SOA": this.printNominee
            }
            checkSum = this.erefNo + '' + '';
        } else {
            params = {
                "ReferenceNumber": this.erefNo,
                // Derived, so Nominee and NomineeFlag can never disagree.
                "Nominee": this.nominee === 'Y',
                "NomineeFlag": this.nominee,
                "NomineeInfo": [],
                "SOA": this.printNominee
            }
                 const clientMobile = sessionStorage.getItem('ClientMobile') || '';
const clientCountryCode = sessionStorage.getItem('CountryCode') || '';
const clientFullMobile = clientCountryCode + clientMobile;
           if (
        this.nominee1 &&
        this.nominee1.NomineeFirstName && this.nominee1.NomineeLastName &&
        this.nominee1.NomineeRelationship
      ) {
        // Date of birth applies only to a minor nominee.
        if (this.nominee1.IsGuardian && !this.nominee1.NomineeDOB) {
          this.errorMsg = 'Please select date of birth for Nominee 1.';
          error++;
        }
        // this.share1 = parseInt(this.nominee1.Share);
        this.share1 = this.nominee1?.NomineeShare
          ? parseInt(this.nominee1.NomineeShare)
          : this.nominee1.Share;
        const ccode =
          typeof this.nominee1.NomineeCountryCode === 'string'
            ? this.nominee1.NomineeCountryCode
            : this.nominee1.NomineeCountryCode?.TeleCode;
        if (this.fullName(this.nominee1).toLowerCase() ===
          sessionStorage.getItem('ClientName')?.toLowerCase() 
      ) {
        this.errorMsg = 'Client name and Nominee 1 name are cannot be same';
        error++;
      }
        // Aadhaar/PAN validation for Nominee 1
        if (
          this.nominee1.Idproof === 'A' &&
          !aadhaarPattern.test(this.nominee1.IdNum)
        ) {
          this.errorComp.ModalShow('Please enter the last 4 digits of Aadhaar for Nominee 1.');
          this.updateNomineeStatus.emit(false);
          return;
        }
        if (
          this.nominee1.Idproof === 'P' &&
          !panPattern.test(this.nominee1.IdNum)
        ) {
          this.errorComp.ModalShow('Please enter a valid PAN (e.g., ABCPE1234F) for Nominee 1.');
          this.updateNomineeStatus.emit(false);
          return;
        }
       if (
        this.nominee1.IdNum &&
        sessionStorage.getItem('NomPan')?.toLowerCase() === this.nominee1.IdNum.toLowerCase()
      ) {
        this.errorComp.ModalShow('Client and nominee1 PAN number cannot be the same');
        this.updateNomineeStatus.emit(false);
        return;
      }
         if (this.nominee1.NomineeEmail && sessionStorage.getItem('ClientEmail')?.toLowerCase() === this.nominee1.NomineeEmail.toLowerCase()) {
            this.errorComp.ModalShow('Client and nominee1 Email ID cannot be the same');
            this.updateNomineeStatus.emit(false);
            return;
          }
        if (
          this.nominee1.NomineeMobile &&
          this.nominee1.NomineeMobile.toString().length < 7
        ) {
          this.errorComp.ModalShow('Nominee 1 mobile number must be at least 7 digits.');
          this.updateNomineeStatus.emit(false);
          return;
        }

        if (
          this.nominee1.NomineeEmail &&
          !emailPattern.test(this.nominee1.NomineeEmail)
        ) {
          this.errorComp.ModalShow('Please enter a valid email address (e.g. john@gmail.com). for Nominee 1.');
          this.updateNomineeStatus.emit(false);
          return;
        }
             if (this.nominee1.NomineeMobile && this.nominee1.NomineeCountryCode &&
               this.nominee1.NomineeCountryCode + this.nominee1.NomineeMobile === clientFullMobile) {
               this.errorComp.ModalShow(`Nominee 1 mobile number should not be same as client mobile number.`);
               this.updateNomineeStatus.emit(false);
               return;
             }

        // Guardian Aadhaar/PAN validation for Nominee 1
        if (this.nominee1.IsGuardian === true) {
          // A minor must have the guardian's relationship recorded.
          if (!this.nominee1.GuardianRelationship) {
            this.errorMsg = 'Please select relationship with applicant for Guardian 1.';
            error++;
          }
          if (
            this.nominee1.GuardianIdProof === 'A' &&
            !aadhaarPattern.test(this.nominee1.GuardianIdProofNumber)
          ) {
            this.errorComp.ModalShow('Please enter the last 4 digits of Aadhaar for Guardian 1.');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
            this.nominee1.GuardianIdProof === 'P' &&
            !panPattern.test(this.nominee1.GuardianIdProofNumber)
          ) {
            this.errorComp.ModalShow('Please enter a valid PAN (e.g., ABCPE1234F) for Guardian 1.');
            this.updateNomineeStatus.emit(false);
            return;
          }
           if (this.nominee1.GuardianEmail && sessionStorage.getItem('ClientEmail')?.toLowerCase() === this.nominee1.GuardianEmail.toLowerCase()) {
            this.errorComp.ModalShow('Client and Guardian1 Email ID cannot be the same');
            this.updateNomineeStatus.emit(false);
            return;
          }
           if (
        this.nominee1.GuardianIdProofNumber &&
        sessionStorage.getItem('NomPan')?.toLowerCase() === this.nominee1.GuardianIdProofNumber.toLowerCase()
      ) {
        this.errorComp.ModalShow('Client and Guardian1 PAN number cannot be the same');
        this.updateNomineeStatus.emit(false);
        return;
      }
          if (
            this.nominee1.GuardianMobile &&
            this.nominee1.GuardianMobile.toString().length < 7
          ) {
            this.errorComp.ModalShow('Guardian 1 mobile number must be at least 7 digits.');
            this.updateNomineeStatus.emit(false);
            return;
          }

          if (
            this.nominee1.GuardianEmail &&
            !emailPattern.test(this.nominee1.GuardianEmail)
          ) {
            this.errorComp.ModalShow('Please enter a valid email address (e.g. john@gmail.com). for Nominee 1.');
            this.updateNomineeStatus.emit(false);
            return;
          }
           if (this.nominee1.GuardianMobile && this.nominee1.NomineeCountryCode &&
               this.nominee1.NomineeCountryCode + this.nominee1.GuardianMobile === clientFullMobile) {
               this.errorComp.ModalShow(`Guardian 1 mobile number should not be same as client mobile number.`);
               this.updateNomineeStatus.emit(false);
               return;
             }
        }
        params.NomineeInfo.push({
          NomineeName: '',
          NomineeFirstName: this.nominee1.NomineeFirstName || '',
          NomineeLastName: this.nominee1.NomineeLastName || '',
          NomineeFlag: this.nominee,
          DOB: this.nominee1.NomineeDOB,
          NomineeMobile: this.nominee1.NomineeMobile,
          NomineeCountryCode: ccode,
          NomineeEmail: this.nominee1.NomineeEmail,
          NomineeRelation: this.nominee1.NomineeRelationship,
          Share: this.nominee1?.NomineeShare
            ? parseInt(this.nominee1.NomineeShare)
            : parseInt(this.nominee1.Share),
          Address: '',
          IsGuardian: this.nominee1.IsGuardian,
          NomineeInfoId: this.nominee1InfoId,
          NomineeIdProof: this.nominee1.Idproof,
          NomineeIdProofNumber: this.nominee1.IdNum,
        });
        if (this.nominee1.IsGuardian) {
          let ccode =
            typeof this.nominee1.GuardianCountryCode === 'string'
              ? this.nominee1.GuardianCountryCode
              : this.nominee1.GuardianCountryCode?.TeleCode;
          // Every guardian field is optional, so whatever was entered is sent
          // as-is and nothing here blocks submission.
          params.NomineeInfo[0].GuardianName = '';
          params.NomineeInfo[0].GuardianFirstName = this.nominee1.GuardianFirstName || '';
          params.NomineeInfo[0].GuardianLastName = this.nominee1.GuardianLastName || '';
          params.NomineeInfo[0].GuardianDOB = '';
          params.NomineeInfo[0].GuardianRelation =
            this.nominee1.GuardianRelationship || '';
          params.NomineeInfo[0].GuardianMobile = this.nominee1.GuardianMobile || '';
          params.NomineeInfo[0].GuardianEmail = this.nominee1.GuardianEmail || '';
          params.NomineeInfo[0].GuardianCountryCode = ccode || '';
          params.NomineeInfo[0].GuardianIdProof =
            this.nominee1.GuardianIdProof || '';
          params.NomineeInfo[0].GuardianIdProofNumber =
            this.nominee1.GuardianIdProofNumber || '';
        }
      } else {
        this.errorMsg = 'Please Complete Nominee 1 Info';
        error++;
      }

           if (
        this.nominee1 &&
        ((error === 0 && this.nomineeArray.length === 2) ||
          this.nomineeArray.length === 3 )
      ) {
        if (
          this.nominee1 &&
          this.nominee2 &&
          this.fullName(this.nominee2).toLowerCase() ===
            this.fullName(this.nominee1).toLowerCase()
        ) {
          this.errorMsg = 'Nominee 1 and 2 name are same';
          error++;
        } else if (
          this.nominee2 &&
          this.nominee2.NomineeFirstName && this.nominee2.NomineeLastName &&
          this.nominee2.NomineeRelationship
        ) {
          // Date of birth applies only to a minor nominee.
          if (this.nominee2.IsGuardian && !this.nominee2.NomineeDOB) {
            this.errorMsg = 'Please select date of birth for Nominee 2.';
            error++;
          }
          this.share2 = this.nominee2?.NomineeShare
            ? parseInt(this.nominee2.NomineeShare)
            : this.nominee2.Share;
          let ccode =
            typeof this.nominee2.NomineeCountryCode === 'string'
              ? this.nominee2.NomineeCountryCode
              : this.nominee2.NomineeCountryCode?.TeleCode;
              if (this.fullName(this.nominee2).toLowerCase() ===
            sessionStorage.getItem('ClientName')?.toLowerCase() 
        ) {
          this.errorMsg = 'Client name and Nominee 2 name are cannot be same';
          error++;
        }
          if (
            this.nominee2.Idproof === 'A' &&
            !aadhaarPattern.test(this.nominee2.IdNum)
          ) {
            this.errorComp.ModalShow('Please enter the last 4 digits of Aadhaar for Nominee 2.');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
            this.nominee2.Idproof === 'P' &&
            !panPattern.test(this.nominee2.IdNum)
          ) {
            this.errorComp.ModalShow('Please enter a valid PAN (e.g., ABCPE1234F) for Nominee 2.');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
        this.nominee2.IdNum &&
        sessionStorage.getItem('NomPan')?.toLowerCase() === this.nominee2.IdNum.toLowerCase()
      ) {
        this.errorComp.ModalShow('Client and nominee2 PAN number cannot be the same');
        this.updateNomineeStatus.emit(false);
        return;
      }
           if (this.nominee2.NomineeEmail && sessionStorage.getItem('ClientEmail')?.toLowerCase() === this.nominee2.NomineeEmail.toLowerCase()) {
            this.errorComp.ModalShow('Client and nominee2 Email ID cannot be the same');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
            this.nominee2.NomineeMobile &&
            this.nominee2.NomineeMobile.toString().length < 7
          ) {
            this.errorComp.ModalShow('Nominee 2 mobile number must be at least 7 digits.');
            this.updateNomineeStatus.emit(false);
            return;
          }

          if (
            this.nominee2.NomineeEmail &&
            !emailPattern.test(this.nominee2.NomineeEmail)
          ) {
            this.errorComp.ModalShow('Please enter a valid email address (e.g. john@gmail.com). for Nominee 2.');
            this.updateNomineeStatus.emit(false);
            return;
          }
           if (this.nominee2.NomineeMobile && this.nominee2.NomineeCountryCode &&
               this.nominee2.NomineeCountryCode + this.nominee2.NomineeMobile === clientFullMobile) {
               this.errorComp.ModalShow(`Nominee 2 mobile number should not be same as client mobile number.`);
               this.updateNomineeStatus.emit(false);
               return;
             }
          // Guardian Aadhaar/PAN validation for Nominee 2
          if (this.nominee2.IsGuardian === true) {
            // A minor must have the guardian's relationship recorded.
            if (!this.nominee2.GuardianRelationship) {
              this.errorMsg = 'Please select relationship with applicant for Guardian 2.';
              error++;
            }
            if (
              this.nominee2.GuardianIdProof === 'A' &&
              !aadhaarPattern.test(this.nominee2.GuardianIdProofNumber)
            ) {
              this.errorComp.ModalShow('Please enter the last 4 digits of Aadhaar for Guardian 2.');
              this.updateNomineeStatus.emit(false);
              return;
            }
            if (
              this.nominee2.GuardianIdProof === 'P' &&
              !panPattern.test(this.nominee2.GuardianIdProofNumber)
            ) {
              this.errorComp.ModalShow('Please enter a valid PAN (e.g., ABCPE1234F) for Guardian 2.');
              this.updateNomineeStatus.emit(false);
              return;
            }
             if (this.nominee2.GuardianEmail && sessionStorage.getItem('ClientEmail')?.toLowerCase() === this.nominee2.GuardianEmail.toLowerCase()) {
            this.errorComp.ModalShow('Client and Guardian2 Email ID cannot be the same');
            this.updateNomineeStatus.emit(false);
            return;
          }
              if (
        this.nominee2.GuardianIdProofNumber &&
        sessionStorage.getItem('NomPan')?.toLowerCase() === this.nominee2.GuardianIdProofNumber.toLowerCase()
      ) {
        this.errorComp.ModalShow('Client and Guardian2 PAN number cannot be the same');
        this.updateNomineeStatus.emit(false);
        return;
      }
            if (
              this.nominee2.GuardianMobile &&
              this.nominee2.GuardianMobile.toString().length < 7
            ) {
              this.errorComp.ModalShow('Guardian 2 mobile number must be at least 7 digits.');
              this.updateNomineeStatus.emit(false);
              return;
            }

            if (
              this.nominee2.GuardianEmail &&
              !emailPattern.test(this.nominee2.GuardianEmail)
            ) {
              this.errorComp.ModalShow('Please enter a valid email address (e.g. john@gmail.com). for Nominee 2.');
              this.updateNomineeStatus.emit(false);
              return;
            }
             if (this.nominee2.GuardianMobile && this.nominee2.NomineeCountryCode &&
               this.nominee2.NomineeCountryCode + this.nominee2.GuardianMobile === clientFullMobile) {
               this.errorComp.ModalShow(`Guardian 2 mobile number should not be same as client mobile number.`);
               this.updateNomineeStatus.emit(false);
               return;
             }
          }
          params.NomineeInfo.push({
            NomineeName: '',
            NomineeFirstName: this.nominee2.NomineeFirstName || '',
            NomineeLastName: this.nominee2.NomineeLastName || '',
            NomineeFlag: this.nominee,
            DOB: this.nominee2.NomineeDOB,
            NomineeMobile: this.nominee2.NomineeMobile,
            NomineeCountryCode: ccode,
            NomineeEmail: this.nominee2.NomineeEmail,
            NomineeRelation: this.nominee2.NomineeRelationship,
            Share: this.nominee2?.NomineeShare
              ? parseInt(this.nominee2.NomineeShare)
              : parseInt(this.nominee2.Share),
            Address: '',
            IsGuardian: this.nominee2.IsGuardian,
            NomineeInfoId: this.nominee2InfoId,
            NomineeIdProof: this.nominee2.Idproof,
            NomineeIdProofNumber: this.nominee2.IdNum,
          });
          if (this.nominee2.IsGuardian) {
            let ccode =
              typeof this.nominee2.GuardianCountryCode === 'string'
                ? this.nominee2.GuardianCountryCode
                : this.nominee2.GuardianCountryCode?.TeleCode;
            // Every guardian field is optional, so whatever was entered is
            // sent as-is and nothing here blocks submission.
            params.NomineeInfo[1].GuardianName = '';
            params.NomineeInfo[1].GuardianFirstName = this.nominee2.GuardianFirstName || '';
            params.NomineeInfo[1].GuardianLastName = this.nominee2.GuardianLastName || '';
            params.NomineeInfo[1].GuardianDOB = '';
            params.NomineeInfo[1].GuardianRelation =
              this.nominee2.GuardianRelationship || '';
            params.NomineeInfo[1].GuardianMobile =
              this.nominee2.GuardianMobile || '';
            params.NomineeInfo[1].GuardianEmail = this.nominee2.GuardianEmail || '';
            params.NomineeInfo[1].GuardianCountryCode = ccode || '';
            params.NomineeInfo[1].GuardianIdProof =
              this.nominee2.GuardianIdProof || '';
            params.NomineeInfo[1].GuardianIdProofNumber =
              this.nominee2.GuardianIdProofNumber || '';
          }
        } else {
          this.errorMsg = 'Please Complete Nominee 2 Info';
          error++;
        }
      }

            if ((this.nominee1 && this.nominee2) && (error === 0 && this.nomineeArray.length === 3)) {
                if ((this.nominee1 && this.nominee3) && (this.fullName(this.nominee3).toLowerCase() === this.fullName(this.nominee1).toLowerCase())) {
                    this.errorMsg = "Nominee 1 and 3 name are same";
                    error++;
                }
                else if ((this.nominee3 && this.nominee2) && (this.fullName(this.nominee3).toLowerCase() === this.fullName(this.nominee2).toLowerCase())) {
                    this.errorMsg = "Nominee 2 and 3 name are same";
                    error++;
                }
                else if (
          this.nominee3 &&
          this.nominee3.NomineeFirstName && this.nominee3.NomineeLastName &&
          this.nominee3.NomineeRelationship
        ) {
          // Date of birth applies only to a minor nominee.
          if (this.nominee3.IsGuardian && !this.nominee3.NomineeDOB) {
            this.errorMsg = 'Please select date of birth for Nominee 3.';
            error++;
          }
          this.share3 = this.nominee3?.NomineeShare
            ? parseInt(this.nominee3.NomineeShare)
            : this.nominee3.Share;
          let ccode =
            typeof this.nominee3.NomineeCountryCode === 'string'
              ? this.nominee3.NomineeCountryCode
              : this.nominee3.NomineeCountryCode?.TeleCode;
              if (this.fullName(this.nominee3).toLowerCase() ===
            sessionStorage.getItem('ClientName')?.toLowerCase() 
        ) {
          this.errorMsg = 'Client name and Nominee 3 name are cannot be same';
          error++;
        }
          if (
            this.nominee3.Idproof === 'A' &&
            !aadhaarPattern.test(this.nominee3.IdNum)
          ) {
            this.errorComp.ModalShow('Please enter the last 4 digits of Aadhaar for Nominee 3.');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
            this.nominee3.Idproof === 'P' &&
            !panPattern.test(this.nominee3.IdNum)
          ) {
            this.errorComp.ModalShow('Please enter a valid PAN (e.g., ABCPE1234F) for Nominee 3.');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
        this.nominee3.IdNum &&
        sessionStorage.getItem('NomPan')?.toLowerCase() === this.nominee3.IdNum.toLowerCase()
      ) {
        this.errorComp.ModalShow('Client and nominee3 PAN number cannot be the same');
        this.updateNomineeStatus.emit(false);
        return;
      }
          if (this.nominee3.NomineeEmail && sessionStorage.getItem('ClientEmail')?.toLowerCase() === this.nominee3.NomineeEmail.toLowerCase()) {
            this.errorComp.ModalShow('Client and nominee3 Email ID cannot be the same');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (
            this.nominee3.NomineeMobile &&
            this.nominee3.NomineeMobile.toString().length < 7
          ) {
            this.errorComp.ModalShow('Nominee 3 mobile number must be at least 7 digits.');
            this.updateNomineeStatus.emit(false);
            return;
          }

          if (
            this.nominee3.NomineeEmail &&
            !emailPattern.test(this.nominee3.NomineeEmail)
          ) {
            this.errorComp.ModalShow('Please enter a valid email address (e.g. john@gmail.com). for Nominee 3.');
            this.updateNomineeStatus.emit(false);
            return;
          }
          if (this.nominee3.NomineeMobile && this.nominee3.NomineeCountryCode &&
              this.nominee3.NomineeCountryCode + this.nominee3.NomineeMobile === clientFullMobile) {
              this.errorComp.ModalShow(`Nominee 3 mobile number should not be same as client mobile number.`);
              this.updateNomineeStatus.emit(false);
              return;
            }
          // Guardian Aadhaar/PAN validation for Nominee 3
          if (this.nominee3.IsGuardian === true) {
            // A minor must have the guardian's relationship recorded.
            if (!this.nominee3.GuardianRelationship) {
              this.errorMsg = 'Please select relationship with applicant for Guardian 3.';
              error++;
            }
            if (
              this.nominee3.GuardianIdProof === 'A' &&
              !aadhaarPattern.test(this.nominee3.GuardianIdProofNumber)
            ) {
              this.errorComp.ModalShow('Please enter the last 4 digits of Aadhaar for Guardian 3.');
              this.updateNomineeStatus.emit(false);
              return;
            }
            if (
              this.nominee3.GuardianIdProof === 'P' &&
              !panPattern.test(this.nominee3.GuardianIdProofNumber)
            ) {
              this.errorComp.ModalShow('Please enter a valid PAN (e.g., ABCPE1234F) for Guardian 3.');
              this.updateNomineeStatus.emit(false);
              return;
            }
             if (this.nominee3.GuardianEmail && sessionStorage.getItem('ClientEmail')?.toLowerCase() === this.nominee3.GuardianEmail.toLowerCase()) {
            this.errorComp.ModalShow('Client and Guardian3 Email ID cannot be the same');
            this.updateNomineeStatus.emit(false);
            return;
          }
            if (
        this.nominee3.GuardianIdProofNumber &&
        sessionStorage.getItem('NomPan')?.toLowerCase() === this.nominee3.GuardianIdProofNumber.toLowerCase()
      ) {
        this.errorComp.ModalShow('Client and Guardian3 PAN number cannot be the same');
        this.updateNomineeStatus.emit(false);
        return;
      }
            if (
              this.nominee3.GuardianMobile &&
              this.nominee3.GuardianMobile.toString().length < 7
            ) {
              this.errorComp.ModalShow('Guardian 3 mobile number must be at least 7 digits.');
              this.updateNomineeStatus.emit(false);
              return;
            }

            if (
              this.nominee3.GuardianEmail &&
              !emailPattern.test(this.nominee3.GuardianEmail)
            ) {
              this.errorComp.ModalShow('Please enter a valid email address (e.g. john@gmail.com). for Nominee 3.');
              this.updateNomineeStatus.emit(false);
              return;
            }
            if (this.nominee3.GuardianMobile && this.nominee3.NomineeCountryCode &&
                this.nominee3.NomineeCountryCode + this.nominee3.GuardianMobile === clientFullMobile) {
                this.errorComp.ModalShow(`Guardian 3 mobile number should not be same as client mobile number.`);
                this.updateNomineeStatus.emit(false);
                return;
              }
          }
          params.NomineeInfo.push({
            NomineeName: '',
            NomineeFirstName: this.nominee3.NomineeFirstName || '',
            NomineeLastName: this.nominee3.NomineeLastName || '',
            NomineeFlag: this.nominee,
            DOB: this.nominee3.NomineeDOB,
            NomineeMobile: this.nominee3.NomineeMobile,
            NomineeCountryCode: ccode,
            NomineeEmail: this.nominee3.NomineeEmail,
            NomineeRelation: this.nominee3.NomineeRelationship,
            Share: this.nominee3?.NomineeShare
              ? parseInt(this.nominee3.NomineeShare)
              : this.nominee3.Share,
            Address: '',
            IsGuardian: this.nominee3.IsGuardian,
            NomineeInfoId: this.nominee3InfoId,
            NomineeIdProof: this.nominee3.Idproof,
            NomineeIdProofNumber: this.nominee3.IdNum,
          });
          // if (this.nominee3.NomineeAddressType === 'O') {
          //   if (this.nominee3.Address1) {
          //     params.NomineeInfo[2].Address1 = this.nominee3.Address1;
          //     params.NomineeInfo[2].Address2 = this.nominee3.Address2;
          //     params.NomineeInfo[2].Address3 = this.nominee3.Address3;
          //     params.NomineeInfo[2].City = this.nominee3.City;
          //     params.NomineeInfo[2].State = this.nominee3.State;
          //     params.NomineeInfo[2].Pincode = this.nominee3.Pincode;
          //     params.NomineeInfo[2].Country = this.nominee3.Country;
          //   } else {
          //     this.errorMsg = 'Please Complete Nominee 3 Address';
          //     error++;
          //   }
          // }
          if (this.nominee3.IsGuardian) {
            let ccode =
              typeof this.nominee3.GuardianCountryCode === 'string'
                ? this.nominee3.GuardianCountryCode
                : this.nominee3.GuardianCountryCode?.TeleCode;
            // Every guardian field is optional, so whatever was entered is
            // sent as-is and nothing here blocks submission.
            params.NomineeInfo[2].GuardianName = '';
            params.NomineeInfo[2].GuardianFirstName = this.nominee3.GuardianFirstName || '';
            params.NomineeInfo[2].GuardianLastName = this.nominee3.GuardianLastName || '';
            params.NomineeInfo[2].GuardianDOB = '';
            params.NomineeInfo[2].GuardianRelation =
              this.nominee3.GuardianRelationship || '';
            // params.NomineeInfo[2].GuardianAddress =
            //   this.nominee3.GuardianAddressType;
            params.NomineeInfo[2].GuardianMobile =
              this.nominee3.GuardianMobile || '';
            params.NomineeInfo[2].GuardianEmail = this.nominee3.GuardianEmail || '';
            params.NomineeInfo[2].GuardianCountryCode = ccode || '';
            params.NomineeInfo[2].GuardianIdProof =
              this.nominee3.GuardianIdProof || '';
            params.NomineeInfo[2].GuardianIdProofNumber =
              this.nominee3.GuardianIdProofNumber || '';
            // } else {
            //   this.errorMsg = 'Please Complete Guardian 3 Info';
            //   error++;
            // }
            // if (this.nominee3.GuardianAddressType === 'O') {
            //   if (this.nominee3.GAddress1) {
            //     params.NomineeInfo[2].GAddress1 = this.nominee3.GAddress1;
            //     params.NomineeInfo[2].GAddress2 = this.nominee3.GAddress2;
            //     params.NomineeInfo[2].GAddress3 = this.nominee3.GAddress3;
            //     params.NomineeInfo[2].GCity = this.nominee3.GCity;
            //     params.NomineeInfo[2].GState = this.nominee3.GState;
            //     params.NomineeInfo[2].GPincode = this.nominee3.GPincode;
            //     params.NomineeInfo[2].GCountry = this.nominee3.GCountry;
            //   } else {
            //     this.errorMsg = 'Please Complete Guardian 3 Address';
            //     error++;
            //   }
            //}
          }
        } else {
          this.errorMsg = 'Please Complete Nominee 3 Info';
          error++;
        }
            }
        }
//           const clientMobile = sessionStorage.getItem('ClientMobile') || '';
// const clientCountryCode = sessionStorage.getItem('CountryCode') || '';
// const clientFullMobile = clientCountryCode + clientMobile;

// const nomineeList = [
//   this.nominee1,
//   this.nominee2,
//   this.nominee3,
// ];

// for (let i = 0; i < nomineeList.length; i++) {
//   const nominee = nomineeList[i];

//   if (
//     nominee &&
//     nominee.NomineeMobile &&
//     nominee.NomineeCountryCode &&
//     nominee.NomineeCountryCode + nominee.NomineeMobile === clientFullMobile
//   ) {
//     this.toastr.error(
//       `Nominee ${i + 1} mobile number should not be same as client mobile number.`
//     );
//     return;
//   }
//   if (
//     nominee.IsGuardian &&nominee.GuardianMobile &&
//     nominee.GuardianCountryCode &&
//     nominee.GuardianCountryCode + nominee.GuardianMobile === clientFullMobile
//   ) {
//     this.toastr.error(
//       `Guardian ${i + 1} mobile number should not be same as client mobile number.`
//     );
//     return;
//   }
// }
        this.totalShare = this.share1 + this.share2 + this.share3;
        if (error !== 0) {
            // Tell the FATCA page it failed, otherwise its timer navigates away
            // and takes this popup with it.
            this.updateNomineeStatus.emit(false);
            // this.toastr.error(this.errorMsg)
            this.errorComp.ModalShow(this.errorMsg || 'Please complete the nominee details');
        }
        else if (this.nominee === 'Y' && this.totalShare !== 100) {
            this.updateNomineeStatus.emit(false);
            // this.toastr.error('Combined Nominee share should be equal to 100%');
            this.errorComp.ModalShow('Combined Nominee share should be equal to 100%');
        }
        else if (error === 0) {

            let url = 'DIY/DIYUpdateNominee';
            if (this.nominee === 'N') {
                checkSum = this.erefNo + '' + '';
            } else {
                // NomineeName is sent as an empty string, so the checksum uses '' too.
                checkSum = this.erefNo + '' + (this.nominee1.NomineeDOB || '');
            }
            this.loader.start();
            this._http.httpPost(url, params, checkSum).subscribe({
                next: (data: any) => {
                    let value = this.http.decryptUsingAES256(data.OutPut)
                    this.loader.stop();
                    if (value && value.IsSuccess) {
                        // this.toastr.success(value.Success);
                        sessionStorage.setItem("nomineeStage", JSON.stringify(value.IsSuccess));
                        this.updateNomineeStatus.emit(true);
                        // this.router.navigate(['/photo'], { replaceUrl: true });
                    }
                    if (value && !value.IsSuccess && this.nominee === 'Y') {
                        // this.toastr.error(value.Error);
                        this.errorComp.ModalShow(value.Error);
                        sessionStorage.setItem("nomineeStage", JSON.stringify(!value.IsSuccess));
                        this.updateNomineeStatus.emit(false);
                        return;
                    }

                },
                error: (value: any) => {
                    this.loader.stop();
                    // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
                    this.errorComp.ModalShow('It appears that your internet connectivity is slow or please try again.');
                }
            })

        }
    }



    updateStage() {
        // This save carries no NomineeInfo, so running it while the customer has
        // chosen Yes would blank their nominees and send Nominee:false alongside
        // NomineeFlag:'Y' - a combination that must never reach the API.
        if (this.nominee === 'Y') {
            return;
        }
        let params = {
            "ReferenceNumber": this.erefNo,
            // Derived, so Nominee and NomineeFlag can never disagree.
            "Nominee": this.nominee === 'Y',
            "NomineeFlag": this.nominee,
            "NomineeInfo": [],
            "SOA": this.printNominee
        }
        let checkSum = this.erefNo + '' + '';
        let url = 'DIY/DIYUpdateNominee';
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                //this.getNomineeDetails();
                let stageVal = this.http.decryptUsingAES256(data.OutPut)
                this.loader.stop();
                // this.router.navigate(['/photo'], { replaceUrl: true });
            },
            error: error => {
                // Without this the spinner would never stop if the save failed.
                this.loader.stop();
                if (!window.navigator.onLine) {
                    this.errorComp.ModalShow('It appears that your internet connectivity is slow or please try again.');
                } else {
                    this.errorComp.ModalShow(error.error.Message);
                }
            }
        });
    }

    updateDeleteNominee() {

        if (this.nomineeGetData.length === 1) {
            this.nomineeGetData[0].Share = 100;
        } else {
            this.nomineeGetData.forEach((e: any) => {
                e.Share = 50;
            });
        }

        this.share1 = 0;
        this.share2 = 0;
        this.share3 = 0;

        let params = {
            "ReferenceNumber": this.erefNo,
            // Derived, so Nominee and NomineeFlag can never disagree.
            "Nominee": this.nominee === 'Y',
            "NomineeFlag": this.nominee,
            "NomineeInfo": this.nomineeGetData,
            "SOA": this.printNominee
        }

        let checkSum;

        if (this.nominee === 'N') {
            checkSum = this.erefNo + '' + '';
        } else {
            checkSum = this.erefNo + (this.nomineeGetData[0].NomineeName || '') + (this.nomineeGetData[0].DOB || '');
        }
        let url = 'DIY/DIYUpdateNominee';
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                let value1 = this.http.decryptUsingAES256(data.OutPut);
                this.loader.stop();
                this.getNomineeDetails();
            }
        });
    }

    backStage() {
        this.router.navigate(['/fatca'], { replaceUrl: true });
    }
    SOAChange(val: any) {
        console.log('Selected Value:', val);
        if (val.target.value === 'Y') {
            this.printNominee = 'Y'
        } else {
            this.printNominee = 'N'
        }
    }
}